import moment from '@phoenix/moment';
import MomentTZ from 'moment-timezone';

export const weekdays = {
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday',
  7: 'sunday',
};

export const currentWeekday = weekdays[moment().isoWeekday()];

export const getMomentObjectFromHourString = (hourString, timezone = null) => {
  const [hour, minute] = hourString.split(':');
  const date = timezone ? MomentTZ(moment()).tz(timezone) : moment();
  return date.set({ hour, minute, second: 0 });
};

export const getZoneNameFromTimezone = (timezone) => {
  const zone = MomentTZ.tz(timezone).zoneAbbr();
  return zone.startsWith('+') || zone.startsWith('-') ? `GMT${zone}` : zone;
};
